import { clerkSearchPlayer, clerkRegisteredCustomerPayout, getPlayerAccountPayouts } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    amount: '10',
    playerSearchForm: {
      clerk_search_email: '',
      clerk_search_account_name: '',
      clerk_search_first_name: '',
      clerk_search_last_name: '',
    },
    clerkPlayerSearchStatus: {
      loading: false,
      success: false,
      error: false,
    },
    clerkPlayerSearchResult: [],
    transferFundsStatus: {
      loading: false,
      success: false,
      error: false,
    },
    selectedPlayerId: '',
    registeredPayouts: [],
    getPayoutDetailStatus: {
      loading: false,
      status: false,
    },
  };
};
const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  updateField,
  updateClerkPlayerSearchStatus(state, row) {
    state.clerkPlayerSearchStatus = {
      ...state.clerkPlayerSearchStatus,
      ...row,
    };
  },
  updateGetPayoutDetilStatus(state, row) {
    state.getPayoutDetailStatus = {
      ...state.getPayoutDetailStatus,
      ...row,
    };
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setClerkPlayerSearchResult(state, arr) {
    state.clerkPlayerSearchResult = arr;
  },
  setRegisteredPayouts(state, payouts) {
    state.registeredPayouts = payouts;
  },
  updateTransferFundsStatus(state, row) {
    state.transferFundsStatus = {
      ...state.transferFundsStatus,
      ...row,
    };
  },
};

const actions = {
  tryClerkSearchPlayer({ commit, state }) {
    const formData = {
      account_name: state.playerSearchForm.clerk_search_account_name,
      primary_email: state.playerSearchForm.clerk_search_email,
      first_name: state.playerSearchForm.clerk_search_first_name,
      last_name: state.playerSearchForm.clerk_search_last_name,
    };
    commit('updateClerkPlayerSearchStatus', {
      loading: true,
      success: false,
      error: false,
    });
    clerkSearchPlayer(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('setClerkPlayerSearchResult', r.data.Data.data);
        commit('updateClerkPlayerSearchStatus', {
          loading: false,
          success: true,
          error: false,
        });
      } else {
        commit('updateClerkPlayerSearchStatus', {
          loading: false,
          success: false,
          error: true,
        });
      }
    });
  },
  tryTransferFunds({ commit, state, rootState, dispatch }) {
    if (!state.selectedPlayerId) return;
    if (!state.amount) return;
    const formData = {
      mac_address: rootState.settings.macAddress,
      real_player_id: state.selectedPlayerId,
      amount: state.amount,
      description: 'Epos registered customer transfer',
      reference: 'EPOS',
      user_id: rootState.player.clerk.user_id,
    };
    commit('updateTransferFundsStatus', {
      loading: true,
      success: false,
      error: false,
    });
    clerkRegisteredCustomerPayout(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('updateTransferFundsStatus', {
          loading: false,
          success: 'ClerkLoyalty.TransferSuccess',
          error: false,
        });
        dispatch('tryClerkSearchPlayer');
      } else {
        commit('updateTransferFundsStatus', {
          loading: false,
          success: false,
          error: 'ClerkLoyalty.TransferError',
        });
      }
    });
  },
  tryGetPayoutDetails({ commit, state, rootState, dispatch }) {
    const formData = {
      player_account: state.selectedPlayerAccountName,
    };
    commit('updateGetPayoutDetilStatus', { loading: true, status: false });
    getPlayerAccountPayouts(formData).then(r => {
      if (r.data.IsSuccess) {
        commit('updateGetPayoutDetilStatus', { loading: false, status: true });
        const response = r.data.Data.payouts;
        commit('setRegisteredPayouts', response);
      } else {
        commit('updateGetPayoutDetilStatus', { loading: false, status: false });
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
